import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {Router} from '@angular/router';
import {EditUserPage} from '../../../edit-user/edit-user.page';
import {SessionService} from '../../../services/session.service';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {User} from '../../../../models';
import {Predicates} from 'aws-amplify';

@Component({
    selector: 'app-list-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit,AfterViewInit {

    userList: any;
    u:User;
    filteredUserList: any;
    cssClass: string;
    sortDirection: SortDirection = SortDirection.ASCENDING;
    private filters: any;

    constructor(
        public navController: NavController,
        public apiService: APIService,
        public sessionService: SessionService,
        public router: Router,
        public modalController: ModalController,
    ) {

    }


    async ionViewWillEnter() {
        
        await this.refreshUserList();
    }

    async ngOnInit() {
        // @todo filters

        await this.refreshUserList();
    }
   async ngAfterViewInit(){
        
        await this.refreshUserList();

    }

    private async refreshUserList() {
        this.userList = this.filteredUserList = await DataStore.query(User, Predicates.ALL, {
            sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
        });
        
        if (this.filters)
            this.filterUsers(this.filters);
        // this.applyClassBySelection('rollIn');

    }

    openUserProfile(userId) {
        this.cssClass = '';
        this.router.navigate(['/profile', userId]);
    }

    async addUser() {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: null, isClient: false},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshUserList();
        });
    }

    async edit(userId: string) {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: userId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshUserList();
        });
    }

    async delete(userId: string, i: number) {
        if (confirm('Do you really want to delete this user?')) {
            await DataStore.delete(User, userId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshUserList();
            }, 1000);
        }
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = 'animated ' + effect;
    }

    filterUsers(filters) {
        this.filters = filters;
        

        if (filters['name'].trim().length == 0) {
            this.filteredUserList = this.userList;
        }

        this.filteredUserList = this.userList.filter(u => {
            let matcheNames = '.+';
            let matcheRoles = '.+';

            if (filters['name'].trim().length != 0) matcheNames = filters['name'];
            const reName = new RegExp(matcheNames.toLowerCase(), 'gi');

            if (filters['role'] != 'Tutti') matcheRoles = filters['role'].toLowerCase();
            const reRole = new RegExp(matcheRoles, 'gi');

            let nameMatched = `${u.name?.toLowerCase()} ${u.lastname?.toLowerCase()}`.match(reName);
            let roleMatched = false;
            
            if (matcheRoles == 'client') {
                roleMatched = u.permessions.toLowerCase().match(reRole);
            } else if (matcheRoles == 'administrator') {
                roleMatched = u.permessions.toLowerCase().match(reRole);
            } else if (matcheRoles == 'commercial') {
                roleMatched = u.permessions.toLowerCase().match(reRole);
            } else if (matcheRoles == '.+') {
                roleMatched = true;
            } else {
                roleMatched = u.role?.toLowerCase().match(reRole);
            }
            //   let roleMatched =  u.role?.match(reRole) || u.permessions.match(reRole);
            // make sure we don't take into account users with no name


            return nameMatched && roleMatched;
        });

    }

}
